
import BlokkliComponent_audio_player_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/AudioPlayer/index.vue'
import BlokkliComponent_cleverreach_form_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/CleverReachForm/index.vue'
import BlokkliComponent_csd_service_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/CsdService/index.vue'
import BlokkliComponent_event_list_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/EventList/index.vue'
import BlokkliComponent_filter_page_item_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/FilterPageItem/index.vue'
import BlokkliComponent_iframe_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/Iframe/index.vue'
import BlokkliComponent_logo_pictogramm_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/LogoPictogramm/index.vue'
import BlokkliComponent_mapbs_iframe_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/MapBsIframe/index.vue'
import BlokkliComponent_popular_links_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/PopularLinks/index.vue'
import BlokkliComponent_publication_list_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/PublicationList/index.vue'
import BlokkliComponent_video_remote_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/VideoRemote/index.vue'

const rare: Record<string, any> = {
  block_audio_player: BlokkliComponent_audio_player_index,
  block_cleverreach_form: BlokkliComponent_cleverreach_form_index,
  block_csd_service: BlokkliComponent_csd_service_index,
  block_event_list: BlokkliComponent_event_list_index,
  block_filter_page_item: BlokkliComponent_filter_page_item_index,
  block_iframe: BlokkliComponent_iframe_index,
  block_logo_pictogramm: BlokkliComponent_logo_pictogramm_index,
  block_mapbs_iframe: BlokkliComponent_mapbs_iframe_index,
  block_popular_links: BlokkliComponent_popular_links_index,
  block_publication_list: BlokkliComponent_publication_list_index,
  block_video_remote: BlokkliComponent_video_remote_index
}
export default rare